import React from "react";
import { CarReservation, DistKindEnum, BagSize } from "redmond";
import { Typography, Box } from "@material-ui/core";
import { CarBasicInfo } from "halifax";
import { normalizeVehicleName, getCarDetailsText } from "@capone/common";
import { CAR_DETAILS_MOBILE } from "../../../CarCard/constants";
import { getCancellationPolicy } from "../../../CarCard/helpers";
import {
  CarCancellationPolicy,
  FuelPolicy,
  ViewImportantInformationLink,
} from "../../../CarCard/components/CarInfoContent/component";
import "./styles.scss";

interface ICarBasicInfoModalContentProps {
  car: CarReservation;
}

export const CarBasicInfoModalContent = ({
  car,
}: ICarBasicInfoModalContentProps) => {
  const { bookResult } = car;
  const { rentalRate, vehicle } = bookResult;
  const { passengerQty, bagsInfo } = vehicle;
  const bags = bagsInfo[BagSize.Unspecified];
  const fuelPolicy = rentalRate.extensions.fuelPolicy?.desc;
  return (
    <Box className="car-basic-modal-content">
      <Box className="car-basic-title-container">
        <Typography variant="h4">{CAR_DETAILS_MOBILE}</Typography>
      </Box>
      <Box className="car-info-container">
        <CarBasicInfo
          key={car.bookResult.groundBookingId}
          carModelDetails={{
            carSize: vehicle.label,
            // TODO: ask about where we get multi-car entries
            carModels: [normalizeVehicleName(vehicle.name)],
          }}
          carDetailsText={getCarDetailsText(vehicle.name)}
          carInfoIconDetails={{
            passengerCapacity: passengerQty
              ? `${passengerQty} ${
                  passengerQty > 1 ? "Passengers" : "Passenger"
                }`
              : "0 Passengers",
            bagCapacity: `${bags} ${bags === 1 ? "Bag" : "Bags"}`,
            transmissionType: vehicle.transmissionType,
            airConditioning: vehicle.airConditioning
              ? "Air conditioning"
              : undefined,
          }}
          carAvailabilityTagDetails={{
            freeCancellation: rentalRate.extensions.cancellation.free,
            CancellationPolicy: getCancellationPolicy(bookResult),
            hasUnlimitedMileage:
              rentalRate.extensions.distance.DistKind ===
              DistKindEnum.Unlimited,
          }}
          topRightElement={<Box />}
        />
        <Box className="car-policy-container">
          <Box className="divider" />
          <CarCancellationPolicy car={car} />
        </Box>
        {fuelPolicy && (
          <Box className="car-policy-container">
            <Box className="divider" />
            <FuelPolicy car={car} />
          </Box>
        )}
        <Box className="car-policy-container">
          <Box className="divider" />
          <ViewImportantInformationLink car={car} />
        </Box>
      </Box>
    </Box>
  );
};
